export function generateTwoLetterName(name: string) {
  if (!name) return ''
  return name
    .split(' ')
    .map((part) => part[0]?.toUpperCase())
    .slice(0, 2)
    .join('')
}
